// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"22273151","730":"9f148031","1740":"69ab01a5","2463":"04228d5e","3119":"98bdbd65","4387":"86217605","4807":"9f148031","5615":"04228d5e","6574":"c52a4e0f","7754":"9f148031","8505":"63f3a262","9627":"9f148031"}[chunkId] + ".chunk.css";
};